import { p as proxyCustomElement, H, h, c as Host } from './p-0498a6af.js';
import { i as inheritAriaAttributes, n as nanoid } from './p-ea391b91.js';

const stylesCss = ":host{--bic-icon-size:inherit;display:inline-block;font-size:var(--bic-icon-size)}svg{display:block;width:1em;height:1em;fill:currentColor}:host([data-size='2xl']){--bic-icon-size:var(--bi-icon-2xl) !important}:host([data-size='xl']){--bic-icon-size:var(--bi-icon-xl) !important}:host([data-size='large']){--bic-icon-size:var(--bi-icon-large) !important}:host([data-size='medium']){--bic-icon-size:var(--bi-icon-medium) !important}:host([data-size='small']){--bic-icon-size:var(--bi-icon-small) !important}:host([data-color='inherit']){color:inherit}:host([data-color='primary']){color:#01417b}:host([data-color='gray']){color:#1c1b1b}:host([data-color='black']){color:var(--bi-basic-key)}:host([data-color='white']){color:var(--bi-basic-white)}";
const BiIconPhoneStyle0 = stylesCss;

const BiIconPhone$1 = /*@__PURE__*/ proxyCustomElement(class BiIconPhone extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: '2958943fe4112d755733c065b4cc6244a405d1ab', "data-bi-icon": 'true', "data-size": this.size, "data-color": this.color }, h("svg", { key: '7b509c3acd52c1a2823e713583c6330ba7d8d0a1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: '27e7e38d27d4d714127f8688f40bdfe34e768bd1', "fill-rule": 'evenodd', d: 'M3.875 3.575H9.62v5.493a3.247 3.247 0 0 1-3.246 3.246h-.998v1.996a5.74 5.74 0 0 0 5.741 5.74h1.746v-.747a3.247 3.247 0 0 1 3.247-3.246h5.742v5.494H11.117a7.24 7.24 0 0 1-7.24-7.24V3.574ZM14.362 20.05h5.99v-2.494h-4.243c-.964 0-1.747.782-1.747 1.746zm-8.987-9.237h.998c.964 0 1.746-.782 1.746-1.746V5.075H5.375v5.74Z', "clip-rule": 'evenodd' }))));
    }
    get el() { return this; }
    static get style() { return BiIconPhoneStyle0; }
}, [1, "bi-icon-phone", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-phone"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-phone":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconPhone$1);
            }
            break;
    } });
}

const BiIconPhone = BiIconPhone$1;
const defineCustomElement = defineCustomElement$1;

export { BiIconPhone, defineCustomElement };
